var map = {
	"./'.svg": "1af9",
	"./Afghanistan.png": "9239",
	"./Flag_of_Albania.svg": "2e87",
	"./Flag_of_Algeria.svg": "f300",
	"./Flag_of_Andorra.svg": "c645",
	"./Flag_of_Angola.svg": "9174",
	"./Flag_of_Anguilla.svg": "9d67",
	"./Flag_of_Antigua_and_Barbuda.svg": "5fa3",
	"./Flag_of_Argentina.svg": "6bf7",
	"./Flag_of_Armenia.svg": "96de",
	"./Flag_of_Aruba.svg": "24f0",
	"./Flag_of_Australia.svg": "1e00",
	"./Flag_of_Austria.svg": "3331",
	"./Flag_of_Azerbaijan.svg": "60e0",
	"./Flag_of_Bahrain (1).svg": "393b",
	"./Flag_of_Bahrain.svg": "4bfc",
	"./Flag_of_Bangladesh (1).svg": "f62b",
	"./Flag_of_Bangladesh.svg": "47db",
	"./Flag_of_Barbados (1).svg": "5b56",
	"./Flag_of_Barbados.svg": "febd",
	"./Flag_of_Belarus (1).svg": "e72a",
	"./Flag_of_Belarus.svg": "0ef3",
	"./Flag_of_Belgium (1).svg": "92d5",
	"./Flag_of_Belgium.svg": "fea5",
	"./Flag_of_Belize (1).svg": "0773",
	"./Flag_of_Belize.svg": "6efb",
	"./Flag_of_Benin (1).svg": "fdf0",
	"./Flag_of_Benin.svg": "e016",
	"./Flag_of_Bermuda (1).svg": "24da",
	"./Flag_of_Bermuda.svg": "0d6c",
	"./Flag_of_Bhutan (1).svg": "2ef4",
	"./Flag_of_Bhutan.svg": "5f98",
	"./Flag_of_Bosnia_and_Herzegovina.svg": "6996",
	"./Flag_of_Botswana.svg": "e634",
	"./Flag_of_Brazil.svg": "3416",
	"./Flag_of_Brunei.svg": "b548",
	"./Flag_of_Bulgaria.svg": "4b26",
	"./Flag_of_Burkina_Faso.svg": "1fa0",
	"./Flag_of_Burundi.svg": "0d0a",
	"./Flag_of_Cambodia.svg": "3bfe",
	"./Flag_of_Cameroon.svg": "2982",
	"./Flag_of_Canada.svg": "66a3",
	"./Flag_of_Cape_Verde.svg": "949c",
	"./Flag_of_Chad.svg": "67c0",
	"./Flag_of_Chile.svg": "64da",
	"./Flag_of_Christmas_Island.svg": "f0d9",
	"./Flag_of_Colombia.svg": "6a28",
	"./Flag_of_Croatia.svg": "bb93",
	"./Flag_of_Cuba.svg": "f021",
	"./Flag_of_Cyprus.svg": "4efe",
	"./Flag_of_Denmark.svg": "2c4e",
	"./Flag_of_Djibouti.svg": "bf26",
	"./Flag_of_Dominica.svg": "4618",
	"./Flag_of_East_Timor.svg": "bbd4",
	"./Flag_of_Ecuador.svg": "6d3c",
	"./Flag_of_Egypt.svg": "da3d",
	"./Flag_of_El_Salvador.svg": "962c",
	"./Flag_of_Equatorial_Guinea.svg": "b302",
	"./Flag_of_Eritrea.svg": "92e7",
	"./Flag_of_Estonia.svg": "e666",
	"./Flag_of_Ethiopia.svg": "a90d",
	"./Flag_of_Fiji.svg": "348c",
	"./Flag_of_Finland.svg": "e901",
	"./Flag_of_France (1).svg": "eb8e",
	"./Flag_of_France (2).svg": "fd0b",
	"./Flag_of_France.svg": "7e29",
	"./Flag_of_French_Guiana.svg": "2178",
	"./Flag_of_French_Polynesia.svg": "497f",
	"./Flag_of_Gabon.svg": "6c46",
	"./Flag_of_Georgia.svg": "467b",
	"./Flag_of_Germany.svg": "f2bd",
	"./Flag_of_Gibraltar.svg": "0325",
	"./Flag_of_Greece.svg": "a777",
	"./Flag_of_Greenland.svg": "87e2",
	"./Flag_of_Grenada.svg": "2619",
	"./Flag_of_Guam.svg": "c1c2",
	"./Flag_of_Guatemala.svg": "f637",
	"./Flag_of_Guernsey.svg": "3250",
	"./Flag_of_Guinea-Bissau.svg": "4a3b",
	"./Flag_of_Guinea.svg": "9dba",
	"./Flag_of_Guyana.svg": "b87b",
	"./Flag_of_Haiti.svg": "3979",
	"./Flag_of_Hong_Kong.svg": "bc25",
	"./Flag_of_Hungary.svg": "e821",
	"./Flag_of_Iceland.svg": "9f56",
	"./Flag_of_India.svg": "4904",
	"./Flag_of_Indonesia.svg": "5474",
	"./Flag_of_Iran.svg": "8089",
	"./Flag_of_Iraq.svg": "08b7",
	"./Flag_of_Ireland.svg": "2726",
	"./Flag_of_Israel.svg": "276a",
	"./Flag_of_Italy.svg": "75ed",
	"./Flag_of_Jamaica.svg": "ec55",
	"./Flag_of_Japan.svg": "6f3a",
	"./Flag_of_Jersey.svg": "c56d",
	"./Flag_of_Jordan.svg": "f797",
	"./Flag_of_Kazakhstan.svg": "7fa0",
	"./Flag_of_Kenya.svg": "a8e1",
	"./Flag_of_Kiribati.svg": "09b1",
	"./Flag_of_Kuwait.svg": "e4cd",
	"./Flag_of_Kyrgyzstan.svg": "ceba",
	"./Flag_of_Laos.svg": "6453",
	"./Flag_of_Latvia.svg": "91d1",
	"./Flag_of_Lebanon.svg": "1f36",
	"./Flag_of_Lesotho.svg": "863d",
	"./Flag_of_Liberia.svg": "c1ea",
	"./Flag_of_Liechtenstein.svg": "80f6",
	"./Flag_of_Luxembourg.svg": "12ad",
	"./Flag_of_Macau.svg": "3598",
	"./Flag_of_Madagascar.svg": "505c",
	"./Flag_of_Malawi.svg": "3375",
	"./Flag_of_Malaysia.svg": "b8ad",
	"./Flag_of_Maldives.svg": "2abb",
	"./Flag_of_Mali.svg": "4a49",
	"./Flag_of_Malta.svg": "665d",
	"./Flag_of_Mauritania.svg": "7bb5",
	"./Flag_of_Mauritius.svg": "e1c8",
	"./Flag_of_Mexico.svg": "cdc0",
	"./Flag_of_Monaco.svg": "accc",
	"./Flag_of_Mongolia.svg": "2eec",
	"./Flag_of_Montenegro.svg": "25a9",
	"./Flag_of_Montserrat.svg": "1a80",
	"./Flag_of_Morocco.svg": "6c96",
	"./Flag_of_Mozambique.svg": "3781",
	"./Flag_of_Myanmar.svg": "04c7",
	"./Flag_of_Namibia.svg": "9dce",
	"./Flag_of_Nauru.svg": "5b05",
	"./Flag_of_Nepal.svg": "9fbe",
	"./Flag_of_New_Zealand.svg": "79ff",
	"./Flag_of_Nicaragua.svg": "f606",
	"./Flag_of_Niger.svg": "5deb",
	"./Flag_of_Nigeria.svg": "4e61",
	"./Flag_of_Niue.svg": "751a",
	"./Flag_of_Norfolk_Island.svg": "41ee",
	"./Flag_of_Norway (1).svg": "1b8b",
	"./Flag_of_Norway.svg": "70f6",
	"./Flag_of_Oman.svg": "6a20",
	"./Flag_of_Pakistan.svg": "1389",
	"./Flag_of_Palau.svg": "87a8",
	"./Flag_of_Panama.svg": "86df",
	"./Flag_of_Papua_New_Guinea.svg": "6a44",
	"./Flag_of_Paraguay.svg": "bec8",
	"./Flag_of_Peru.svg": "2c7b",
	"./Flag_of_Poland.svg": "3bdc",
	"./Flag_of_Portugal.svg": "bf95",
	"./Flag_of_Puerto_Rico.svg": "c078",
	"./Flag_of_Qatar.svg": "310d",
	"./Flag_of_Romania.svg": "b0dfd",
	"./Flag_of_Rwanda.svg": "3243",
	"./Flag_of_Saint-Pierre_and_Miquelon.svg": "4366",
	"./Flag_of_Saint_Kitts_and_Nevis.svg": "5715",
	"./Flag_of_Saint_Lucia.svg": "ab22",
	"./Flag_of_Saint_Vincent_and_the_Grenadines.svg": "f4d7",
	"./Flag_of_Samoa.svg": "89a4",
	"./Flag_of_San_Marino.svg": "ea1f",
	"./Flag_of_Sao_Tome_and_Principe.svg": "5c20",
	"./Flag_of_Saudi_Arabia.svg": "0464",
	"./Flag_of_Senegal.svg": "4e9a",
	"./Flag_of_Serbia.svg": "0d4a",
	"./Flag_of_Seychelles.svg": "e730",
	"./Flag_of_Sierra_Leone.svg": "e857",
	"./Flag_of_Singapore.svg": "0397",
	"./Flag_of_Slovakia.svg": "5088",
	"./Flag_of_Slovenia.svg": "a844",
	"./Flag_of_Somalia.svg": "267c",
	"./Flag_of_South_Africa.svg": "c9e3",
	"./Flag_of_South_Georgia_and_the_South_Sandwich_Islands.svg": "6764",
	"./Flag_of_Spain.svg": "cec4",
	"./Flag_of_Sri_Lanka.svg": "eba4",
	"./Flag_of_Sudan.svg": "f5e3",
	"./Flag_of_Suriname.svg": "b985",
	"./Flag_of_Swaziland_1894.svg": "55f3",
	"./Flag_of_Sweden.svg": "02eb",
	"./Flag_of_Switzerland.svg": "fafe",
	"./Flag_of_Syria.svg": "3d93",
	"./Flag_of_Tajikistan.svg": "ce2c",
	"./Flag_of_Thailand.svg": "9a3f",
	"./Flag_of_The_Gambia.svg": "74b0",
	"./Flag_of_Togo.svg": "1153",
	"./Flag_of_Tokelau.svg": "7c1e",
	"./Flag_of_Tonga.svg": "4ccb",
	"./Flag_of_Trinidad_and_Tobago.svg": "fd70",
	"./Flag_of_Tunisia.svg": "dd8e",
	"./Flag_of_Turkey.svg": "2570",
	"./Flag_of_Turkmenistan.svg": "676c",
	"./Flag_of_Tuvalu.svg": "054d",
	"./Flag_of_Uganda.svg": "132c",
	"./Flag_of_Ukraine.svg": "a25e",
	"./Flag_of_Uruguay.svg": "0b8c",
	"./Flag_of_Uzbekistan.svg": "34b7",
	"./Flag_of_Vanuatu.svg": "47db4",
	"./Flag_of_Vietnam.svg": "2792",
	"./Flag_of_Wallis_and_Futuna.svg": "8996",
	"./Flag_of_Yemen.svg": "f8a8",
	"./Flag_of_Zambia.svg": "9291",
	"./Flag_of_Zimbabwe.svg": "ffd1",
	"./Flag_of_the_Bahamas.svg": "8a66",
	"./Flag_of_the_Cayman_Islands.svg": "6b3e",
	"./Flag_of_the_Central_African_Republic.svg": "af40",
	"./Flag_of_the_Cocos_(Keeling)_Islands.svg": "d4b4",
	"./Flag_of_the_Comoros.svg": "a195",
	"./Flag_of_the_Cook_Islands.svg": "ea50",
	"./Flag_of_the_Czech_Republic.svg": "eeea",
	"./Flag_of_the_Dominican_Republic.svg": "4c7f",
	"./Flag_of_the_Falkland_Islands.svg": "5423",
	"./Flag_of_the_Faroe_Islands.svg": "7d13",
	"./Flag_of_the_Isle_of_Man.svg": "1901",
	"./Flag_of_the_Marshall_Islands.svg": "3269",
	"./Flag_of_the_Netherlands.svg": "1ae2",
	"./Flag_of_the_Northern_Mariana_Islands.svg": "6113",
	"./Flag_of_the_People's_Republic_of_China.svg": "3ce8",
	"./Flag_of_the_Philippines.svg": "03a6",
	"./Flag_of_the_Pitcairn_Islands.svg": "dd4d",
	"./Flag_of_the_Republic_of_China.svg": "000f",
	"./Flag_of_the_Republic_of_the_Congo.svg": "c39c",
	"./Flag_of_the_Solomon_Islands.svg": "9f71",
	"./Flag_of_the_United_Arab_Emirates.svg": "a641",
	"./Flag_of_the_United_Kingdom.svg": "b768",
	"./Flag_of_the_United_States (1).svg": "0dd8",
	"./Flag_of_the_United_States.svg": "a956",
	"./Flag_of_the_Vatican_City.svg": "21f6",
	"./Flags_of_New_Caledonia.svg": "55d5",
	"./Naval_Ensign_of_Honduras.svg": "d1d7",
	"./Proposed_flag_of_Antarctica.svg": "2fb0",
	"./Unofficial_flag_of_Guadeloupe.svg": "7bde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4558";